<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Salty Wives, Spirited Mothers, and Savvy Widows</title>
<link href="css/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="css/page-template.xpgt" rel="stylesheet" type="application/adobe-page-template+xml"/>
<p class="content" id="contents"><a id="page_vii"><i>Contents</i></a></p><a id="page_vii">
</a><div><a id="page_vii"></a><a id="pre_1"></a></div><p class="con1i"><a href="#/Preface#pre"><span class="small">PREFACE</span></a></p>
<div class="conte"><a id="ch-01"></a><p class="con1"><a id="ch-01"></a><a href="#/Chapter001#ch01">1. Toward Bluer Skies: Reducing the Threat Level and Resurrecting Feminist Studies of Women in Luke</a></p></div>
<div class="conte"><a id="ch-02"></a><p class="con1"><a id="ch-02"></a><a href="#/Chapter002#ch02">2. Can We Go On Together with Suspicious Minds? Doubt and Trust as Both Sides of the Hermeneutical “Coin” (Luke 15:8-10)</a></p></div>
<div class="conte"><a id="ch-03"></a><p class="con1"><a id="ch-03"></a><span href="#/Chapter003#ch03" title="Link target outside of Sample">3. A Woman’s Right to Choose? Mother Mary as Spirited Agent and Actor (Luke 1–2)</span></p></div>
<div class="conte"><a id="ch-04"></a><p class="con1"><a id="ch-04"></a><span href="#/Chapter004#ch04" title="Link target outside of Sample">4. The Quest for the Historical Joanna: Follower of Jesus, Friend of Mary Magdalene, and Wife of Herod’s Official (Luke 8:1-3; 24:10)</span></p></div>
<div class="conte"><a id="ch-05"></a><p class="con1"><a id="ch-05"></a><span href="#/Chapter005#ch05" title="Link target outside of Sample">5. A Testy Hostess and Her Lazy Sister? Martha, Mary, and the Household Rivals Type-Scene (Luke 10:38-42)</span></p></div>
<div class="conte"><a id="ch-06"></a><p class="con1"><a id="ch-06"></a><span href="#/Chapter006#ch06" title="Link target outside of Sample">6. A Hungry Widow, Spicy Queen, and Salty Wife: “Foreign” Biblical Models of Warning and Judgment (Luke 4:25-26; 11:31; 17:32)</span></p></div>
<div class="conte"><a id="ch-07"></a><p class="con1"><a id="ch-07"></a><span href="#/Chapter007#ch07" title="Link target outside of Sample">7. The Savvy Widow’s Might: Fighting for Justice in an Unjust World (Luke 18:1-8)</span></p></div>
<div class="conte"><a id="ch-08"></a><p class="con1"><a id="ch-08"></a><span href="#/Chapter008#ch08" title="Link target outside of Sample">8. A Capable Woman, Who Can Find? We Have Found Some in Luke!</span></p></div>
<div><a id="index_1"></a></div><p class="con1i"><span href="#/Index#index" title="Link target outside of Sample"><span class="small">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5f77f0ca